import React, { useState } from 'react';
import Select from 'react-select';
import ApexCharts from 'react-apexcharts';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';


const BarCharts = () => {
  const barData = {
    USA: {
      daily: [
        { name: 'Orders', data: [15, 20, 25, 30, 35, 50, 45] },
        { name: 'Revenue', data: [150, 200, 250, 300, 350, 500, 450] },
        { name: 'Units Sold', data: [45, 60, 75, 90, 105, 150, 135] },
        { name: 'Top Selling Product', data: [10, 20, 30, 40, 50, 60, 70] },
        { name: 'Revenue by Category', data: [50, 60, 80, 100, 120, 150, 200] },
      ],
      weekly: [
        { name: 'Orders', data: [100, 120, 140, 160, 180, 200, 220, 240, 260, 280, 300, 320] },
        { name: 'Revenue', data: [1000, 1200, 1400, 1600, 1800, 2000, 2200, 2400, 2600, 2800, 3000, 3200] },
        { name: 'Units Sold', data: [300, 360, 420, 480, 540, 600, 660, 720, 780, 840, 900, 960] },
        { name: 'Top Selling Product', data: [50, 60, 80, 100, 120, 140, 160, 180, 200, 220, 240, 260] },
        { name: 'Revenue by Category', data: [200, 250, 300, 350, 400, 450, 500, 550, 600, 650, 700, 750] },
      ],
      monthly: [
        { name: 'Orders', data: [400, 450, 500, 550, 600, 650, 700, 750, 800, 850, 900, 950] },
        { name: 'Revenue', data: [4000, 4500, 5000, 5500, 6000, 6500, 7000, 7500, 8000, 8500, 9000, 9500] },
        { name: 'Units Sold', data: [1200, 1350, 1500, 1650, 1800, 1950, 2100, 2250, 2400, 2550, 2700, 2850] },
        { name: 'Top Selling Product', data: [200, 250, 300, 350, 400, 450, 500, 550, 600, 650, 700, 750] },
        { name: 'Revenue by Category', data: [400, 500, 600, 700, 800, 900, 1000, 1100, 1200, 1300, 1400, 1500] },
      ],
      yearly: [
        { name: 'Orders', data: [4800, 5400, 6000, 6600] },
        { name: 'Revenue', data: [48000, 54000, 60000, 66000] },
        { name: 'Units Sold', data: [14400, 16200, 18000, 19800] },
        { name: 'Top Selling Product', data: [800, 1000, 1200, 1400] },
        { name: 'Revenue by Category', data: [800, 1000, 1200, 1400] },
      ],
    },
    UK: {
      daily: [
        { name: 'Orders', data: [10, 15, 20, 25, 30, 35, 40] },
        { name: 'Revenue', data: [100, 150, 200, 250, 300, 350, 400] },
        { name: 'Units Sold', data: [30, 45, 60, 75, 90, 100, 110] },
        { name: 'Top Selling Product', data: [5, 10, 20, 25, 30, 35, 40] },
        { name: 'Revenue by Category', data: [30, 50, 70, 90, 110, 130, 150] },
      ],
      weekly: [
        { name: 'Orders', data: [90, 110, 130, 150, 170, 190, 210, 230, 250, 270, 290, 310] },
        { name: 'Revenue', data: [900, 1100, 1300, 1500, 1700, 1900, 2100, 2300, 2500, 2700, 2900, 3100] },
        { name: 'Units Sold', data: [270, 330, 390, 450, 510, 570, 630, 690, 750, 810, 870, 930] },
        { name: 'Top Selling Product', data: [40, 50, 60, 70, 80, 90, 100, 110, 120, 130, 140, 150] },
        { name: 'Revenue by Category', data: [150, 200, 250, 300, 350, 400, 450, 500, 550, 600, 650, 700] },
      ],
      monthly: [
        { name: 'Orders', data: [300, 350, 400, 450, 500, 550, 600, 650, 700, 750, 800, 850] },
        { name: 'Revenue', data: [3000, 3500, 4000, 4500, 5000, 5500, 6000, 6500, 7000, 7500, 8000, 8500] },
        { name: 'Units Sold', data: [900, 1050, 1200, 1350, 1500, 1650, 1800, 1950, 2100, 2250, 2400, 2550] },
        { name: 'Top Selling Product', data: [150, 200, 250, 300, 350, 400, 450, 500, 550, 600, 650, 700] },
        { name: 'Revenue by Category', data: [300, 400, 500, 600, 700, 800, 900, 1000, 1100, 1200, 1300, 1400] },
      ],
      yearly: [
        { name: 'Orders', data: [4000, 4600, 5200, 5800] },
        { name: 'Revenue', data: [40000, 46000, 52000, 58000] },
        { name: 'Units Sold', data: [12000, 13800, 15600, 17400] },
        { name: 'Top Selling Product', data: [600, 750, 900, 1050] },
        { name: 'Revenue by Category', data: [600, 750, 900, 1050] },
      ],
    },
    India: {
      daily: [
        { name: 'Orders', data: [5, 10, 15, 20, 25, 30, 35] },
        { name: 'Revenue', data: [50, 100, 150, 200, 250, 300, 350] },
        { name: 'Units Sold', data: [15, 30, 45, 60, 75, 90, 105] },
        { name: 'Top Selling Product', data: [2, 4, 6, 8, 10, 12, 14] },
        { name: 'Revenue by Category', data: [10, 20, 30, 40, 50, 60, 70] },
      ],
      weekly: [
        { name: 'Orders', data: [50, 60, 70, 80, 90, 100, 110, 120, 130, 140, 150, 160] },
        { name: 'Revenue', data: [500, 600, 700, 800, 900, 1000, 1100, 1200, 1300, 1400, 1500, 1600] },
        { name: 'Units Sold', data: [150, 180, 210, 240, 270, 300, 330, 360, 390, 420, 450, 480] },
        { name: 'Top Selling Product', data: [30, 40, 50, 60, 70, 80, 90, 100, 110, 120, 130, 140] },
        { name: 'Revenue by Category', data: [100, 120, 140, 160, 180, 200, 220, 240, 260, 280, 300, 320] },
      ],
      monthly: [
        { name: 'Orders', data: [200, 250, 300, 350, 400, 450, 500, 550, 600, 650, 700, 750] },
        { name: 'Revenue', data: [2000, 2500, 3000, 3500, 4000, 4500, 5000, 5500, 6000, 6500, 7000, 7500] },
        { name: 'Units Sold', data: [600, 750, 900, 1050, 1200, 1350, 1500, 1650, 1800, 1950, 2100, 2250] },
        { name: 'Top Selling Product', data: [100, 150, 200, 250, 300, 350, 400, 450, 500, 550, 600, 650] },
        { name: 'Revenue by Category', data: [200, 300, 400, 500, 600, 700, 800, 900, 1000, 1100, 1200, 1300] },
      ],
      yearly: [
        { name: 'Orders', data: [3000, 3500, 4000, 4500] },
        { name: 'Revenue', data: [30000, 35000, 40000, 45000] },
        { name: 'Units Sold', data: [9000, 10500, 12000, 13500] },
        { name: 'Top Selling Product', data: [450, 550, 650, 750] },
        { name: 'Revenue by Category', data: [450, 550, 650, 750] },
      ],
    },
  };

  const [selectedCountry, setSelectedCountry] = useState('USA');
  const [selectedTimePeriod, setSelectedTimePeriod] = useState('daily');
  const [selectedChart, setSelectedChart] = useState('Bar Chart');

  const handleCountryChange = (selectedOption) => {
    setSelectedCountry(selectedOption.value);
  };

  const handleTimePeriodChange = (selectedOption) => {
    setSelectedTimePeriod(selectedOption.value);
  };

  const handleChartChange = (selectedOption) => {
    setSelectedChart(selectedOption.value);
  };

 // const currentData = barData[selectedCountry][selectedTimePeriod];

  const getMetricData = (metricName) => {
    const currentData = barData[selectedCountry]?.[selectedTimePeriod]; // Safe access
    if (!currentData) return []; // Return empty array if data is not available
    
    const metric = currentData.find((item) => item.name === metricName);
    return metric ? metric.data : [];
  };
  

  const categories = ['Category 1', 'Category 2', 'Category 3', 'Category 4', 'Category 5'];

  const pieChartOptions = {
    chart: {
      type: 'pie',
      height: 400,
      toolbar: { show: false },
    },
    labels: categories,
    title: {
      text: `Revenue by Category (${selectedCountry})`,
      align: 'center',
      style: { fontSize: '22px', fontWeight: 'bold', color: '#333' },
    },
    plotOptions: {
      pie: {
        donut: {
          size: '60%',
        },
      },
    },
  };

  const pieSeries = getMetricData('Revenue by Category');

  const barChartOptions = {
    chart: {
      type: 'bar',
      height: 400,
    },
    title: {
      text: 'Orders & Revenue',
      align: 'center',
      style: { fontSize: '22px', fontWeight: 'bold', color: '#333' },
    },
    xaxis: {
      categories: categories,
    },
    fill: {
      opacity: 1,
    },
  };

  const barSeries = [
    {
      name: 'Orders',
      data: getMetricData('Orders'),
    },
    {
      name: 'Revenue',
      data: getMetricData('Revenue'),
    },
  ];

  const lineChartOptions = {
    chart: {
      type: 'line',
      height: 400,
    },
    title: {
      text: 'Units Sold Over Time',
      align: 'center',
      style: { fontSize: '22px', fontWeight: 'bold', color: '#333' },
    },
    xaxis: {
      categories: categories,
    },
  };

  const lineSeries = [
    {
      name: 'Units Sold',
      data: getMetricData('Units Sold'),
    },
  ];

  const chartOptions = [
    { value: 'Bar Chart', label: 'Bar Chart' },
    { value: 'Line Chart', label: 'Line Chart' },
    { value: 'Pie Chart', label: 'Pie Chart' },
    { value: 'Table', label: 'Data Table' },
  ];

  return (
    <div className="container">
      <div className="row">
        {/* Filters Column */}
        <div className="col-3">
          <div className="mb-3">
            <label htmlFor="country-select">Select Country</label>
            <Select
              id="country-select"
              options={[
                { value: 'USA', label: 'USA' },
                { value: 'UK', label: 'UK' },
                { value: 'India', label: 'India' },
              ]}
              onChange={handleCountryChange}
              defaultValue={{ value: 'USA', label: 'USA' }}
            />
          </div>

          <div className="mb-3">
            <label htmlFor="time-period-select">Select Time Period</label>
            <Select
              id="time-period-select"
              options={[
                { value: 'daily', label: 'Daily' },
                { value: 'weekly', label: 'Weekly' },
                { value: 'monthly', label: 'Monthly' },
                { value: 'yearly', label: 'Yearly' },
              ]}
              onChange={handleTimePeriodChange}
              defaultValue={{ value: 'daily', label: 'Daily' }}
            />
          </div>

          <div className="mb-3">
            <label htmlFor="chart-select">Select Chart Type</label>
            <Select
              id="chart-select"
              options={chartOptions}
              onChange={handleChartChange}
              defaultValue={{ value: 'Bar Chart', label: 'Bar Chart' }}
            />
          </div>
        </div>

        {/* Charts Column */}
        <div className="col-9">
          {/* Conditional Rendering of Selected Chart */}
          {selectedChart === 'Bar Chart' && (
            <ApexCharts
              options={barChartOptions}
              series={barSeries}
              type="bar"
              height={400}
            />
          )}

          {selectedChart === 'Line Chart' && (
            <ApexCharts
              options={lineChartOptions}
              series={lineSeries}
              type="line"
              height={400}
            />
          )}

          {selectedChart === 'Pie Chart' && (
            <ApexCharts
              options={pieChartOptions}
              series={pieSeries}
              type="pie"
              height={400}
            />
          )}

          {selectedChart === 'Table' && (
            <table className="table table-bordered mt-3">
              <thead>
                <tr>
                  <th>Category</th>
                  <th>Orders</th>
                  <th>Revenue</th>
                  <th>Units Sold</th>
                  <th>Top Selling Product</th>
                </tr>
              </thead>
              <tbody>
                {categories.map((category, index) => (
                  <tr key={index}>
                    <td>{category}</td>
                    <td>{getMetricData('Orders')[index]}</td>
                    <td>{getMetricData('Revenue')[index]}</td>
                    <td>{getMetricData('Units Sold')[index]}</td>
                    <td>{getMetricData('Top Selling Product')[index]}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </div>
  );
};

export default BarCharts;